import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";

export const ApiIntegration: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { Content } = Layout;

  return (
    <Content>
      <div className="card title-card">{t("API_INTEGRATION_TITLE")}</div>
      <div className="mb-1 ml-1">
        <label>{t("API_SURVEY_LABEL")}</label>
      </div>
      <IntegrateApiSettings />
    </Content>
  );
};

const IntegrateApiSettings: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <div className="integration ph-2">
      <div className="mb-1">
        <p>{t("API_SURVEY_BLURB")}</p>
      </div>
      <div
        id="surveyContentEmbed"
        className="card"
        style={{ minHeight: "80px" }}
      ></div>
    </div>
  );
};
